import React, { useMemo } from 'react';
import { ScrollView, StyleSheet, Text } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { PortfolioRiskMonitorCard } from '../../components/portfolio/RiskLimitMonitorCard';

export function RiskScreen() {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const styles = useMemo(() => createThemedStyles(theme), [theme]);

  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={{ paddingVertical: theme.spacing.md }}
    >
      <PortfolioRiskMonitorCard />
      <Text style={styles.disclaimer}>{t('common.advisoryDisclaimer')}</Text>
    </ScrollView>
  );
}

function createThemedStyles(theme: any) {
  return StyleSheet.create({
    container: { flex: 1, backgroundColor: theme.colors.background },
    disclaimer: {
      color: theme.colors.textTertiary,
      fontSize: theme.typography.fontSizeXs,
      marginHorizontal: theme.spacing.lg,
      marginTop: theme.spacing.sm,
    },
  });
}
